import { useQuery } from '@apollo/client';
import { GET_LIST_ROLES } from '../../graphql/queries';

const useGetListRoles = (params = {}) => {
  const { data, loading } = useQuery(GET_LIST_ROLES, {
    variables: {
      limit: params?.limit || 10,
      offset: params?.offset || 0,
      where: {
        deleted_at: null,
        scope: 1,
      },
    },
  });
  return {
    loading,
    data: data?.GetRoleList?.data || [],
  };
};

export default {
  useGetListRoles,
};
